export default {
  apiUrl: 'https://amo-api.vercel.app/api/v1',
};
